<form (submit)="onFormSubmit($event)">
  <div class="d-flex mb-3">
    <dx-text-box [disabled]="this.isDisabled" [(value)]="this.keyWord" class="flex-grow-1 me-2">
      <dx-validator>
        <dxi-validation-rule
          type="pattern"
          [pattern]="keyWordComaPattern"
          message="{{ 'KEY_WORD_VALIDATION_COMA_PATTERN_MESSAGE' | translate }}"></dxi-validation-rule>
      </dx-validator>
    </dx-text-box>
    <dx-button [disabled]="this.isDisabled" text="" icon="add" class="btn" [useSubmitBehavior]="true"></dx-button>
  </div>

  <div class="d-flex flex-wrap">
    @for (keyWord of this.keyWords; track keyWord) {
      <dx-button
        [text]="keyWord"
        icon="mdi mdi-close-thick"
        (onClick)="this.removeKeyWord(keyWord)"
        class="btn btn-light button-icon-close me-2 mb-2"></dx-button>
    }
  </div>

  <dx-validation-summary id="summary"></dx-validation-summary>
</form>
